import { ValidationData } from '../modals/validation-data';
import { FeildValidation } from '../modals/validation-interface';
import { DataSettings } from '../services/data.settings';

export class RequiredValidation implements FeildValidation {
  list: any = [];
  i: number;
  // inputs require data type of Validation data interface name?: string, value?: string, isValid?: boolean,	error?: string,list?: any;
  // output return as same input of data type of validationdata if state is true then isvalid is true
  validation(data: ValidationData): ValidationData {
    if (data.value === null || data.value === '') {
      data.error = `${data.name} feild is required`;
      data.isValid = false;
    }
    return data;
  }

  validationEmail(data: ValidationData): ValidationData {
    const pattern = DataSettings.REGEX.EMAIL;
    if (!pattern.test(data.value.toLowerCase())) {
      data.error = 'Please enter a valid email address.';
      data.isValid = false;
    }
    return data;
  }

  validationPhone(data: ValidationData): ValidationData {
    const pattern = DataSettings.REGEX.MOBILE;
    const validMobile = DataSettings.REGEX.VALIDMOBILE;
    if (
      data.value &&
      (!pattern.test(data.value.toString()) ||
        validMobile.test(data.value.toString()))
    ) {
      // if(data.value.toString().length<10){
      data.error = 'Please enter a valid mobile number';
      data.isValid = false;
    }
    return data;
  }

  validationDate(data: ValidationData): ValidationData {
    if (data.value == 'Invalid Date') {
      data.error = `Please enter a valid ${data.name}`;
      data.isValid = false;
    }
    return data;
  }
}
